<template>
  <div>
    <div v-if="user === 'Client'">
      <div class="row">
        <div class="col-12 text-center mb-3">
          <label>Entrega de información base</label>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div class="circle completado">
            <span class="number">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <span class="text-menu">Solicitantes</span>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div class="circle completado">
            <span class="number">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <span class="text-menu">Ubicación</span>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div class="circle completado">
            <span class="number">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <span class="text-menu">Documentos</span>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', notificacion.currentComponentValues.Cotizacion ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.currentComponentValues.Cotizacion" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Cotizacion' ? 'active-menu' : 'text-menu'" @click="selected('Cotizacion')">
            Cotización
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', notificacion.currentComponentValues.Pago ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.currentComponentValues.Pago" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Pago' ? 'active-menu' : 'text-menu'" @click="selected('Pago')">Pago</a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 justify-content-center">
        <div class="text-center">
          <label>Complementa la información</label>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer" v-if="notificacion.envio == 1">
        <div class="ml-3">
          <div :class="['circle', notificacion.currentComponentValues.EnvioDomicilio ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.currentComponentValues.EnvioDomicilio" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'EnvioDomicilio' ? 'active-menu' : 'text-menu'" @click="selected('EnvioDomicilio')">
            Envío a Domicilio
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', notificacion.currentComponentValues.ComplementaNotificado ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.currentComponentValues.ComplementaNotificado" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'ComplementaNotificado' ? 'active-menu' : 'text-menu'"
            @click="selected('ComplementaNotificado')"
          >
            Notificado
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', notificacion.currentComponentValues.ComplementaSolicitantes ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.currentComponentValues.ComplementaSolicitantes" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'ComplementaSolicitantes' ? 'active-menu' : 'text-menu'"
            @click="selected('ComplementaSolicitantes')"
          >
            Solicitantes
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', notificacion.currentComponentValues.EntregaDocumentos ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.currentComponentValues.EntregaDocumentos" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'EntregaDocumentos' ? 'active-menu' : 'text-menu'"
            @click="selected('EntregaDocumentos')"
          >
            Entrega de documentos
          </a>
        </div>
      </div>
    </div>

    <template v-if="user === 'Staff'">
      <div>
        <div>
          <div class="row flex align-items-center p-2 pointer justify-content-between">
            <div class="ml-3">
              <a :class="selectedComponent === 'Cotizacion' ? 'active-menu' : 'text-menu'" @click="selected('Cotizacion')">
                Cotización
              </a>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-center mb-3">
              <label>Valida la información</label>
            </div>
          </div>

          <div class="row flex align-items-center p-2 pointer justify-content-between">
            <div class="ml-3">
              <a :class="selectedComponent === 'Ubicacion' ? 'active-menu' : 'text-menu'" @click="selected('Ubicacion')">
                Ubicación
              </a>
            </div>

            <div class="mr-3">
              <div :class="['circle', notificacion.validaDomicilio ? 'completado' : '']">
                <span class="number">
                  <i v-if="notificacion.validaDomicilio" class="fa fa-check"></i>
                  <i v-else class="fa fa-minus"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="row flex align-items-center p-2 pointer justify-content-between">
            <div class="ml-3">
              <a :class="selectedComponent === 'Solicitantes' ? 'active-menu' : 'text-menu'" @click="selected('Solicitantes')">
                Solicitantes
              </a>
            </div>
            <div class="mr-3">
              <div :class="['circle', notificacion.validaSolicitantes ? 'completado' : '']">
                <span class="number">
                  <i v-if="notificacion.validaSolicitantes" class="fa fa-check"></i>
                  <i v-else class="fa fa-minus"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="row flex align-items-center p-2 pointer justify-content-between" v-if="!isCorredorAsignado">
            <div class="ml-3">
              <a :class="selectedComponent === 'Notificados' ? 'active-menu' : 'text-menu'" @click="selected('Notificados')">
                Notificados
              </a>
            </div>
            <div class="mr-3">
              <div :class="['circle', notificacion.validaNotificado ? 'completado' : '']">
                <span class="number">
                  <i v-if="notificacion.validaNotificado" class="fa fa-check"></i>
                  <i v-else class="fa fa-minus"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="row flex align-items-center p-2 pointer justify-content-between">
            <div class="ml-3">
              <a :class="selectedComponent === 'Documentos' ? 'active-menu' : 'text-menu'" @click="selected('Documentos')">
                Documentos
              </a>
            </div>
            <div class="mr-3">
              <div :class="['circle', notificacion.validaDocumentos ? 'completado' : '']">
                <span class="number">
                  <i v-if="notificacion.validaDocumentos" class="fa fa-check"></i>
                  <i v-else class="fa fa-minus"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="row flex align-items-center p-2 pointer justify-content-between" v-if="notificacion.envio">
            <div class="ml-3">
              <a
                :class="selectedComponent === 'EnvioDomicilio' ? 'active-menu' : 'text-menu'"
                @click="selected('EnvioDomicilio')"
              >
                Domicilio de Envio
              </a>
            </div>
            <div class="mr-3">
              <div :class="['circle', notificacion.validaEnvio ? 'completado' : '']">
                <span class="number">
                  <i v-if="notificacion.validaEnvio" class="fa fa-check"></i>
                  <i v-else class="fa fa-minus"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer justify-content-between" v-if="!isCorredorAsignado">
        <div class="ml-3">
          <a :class="selectedComponent === 'Correduria' ? 'active-menu' : 'text-menu'" @click="selected('Correduria')">
            Asignar Correduría
          </a>
        </div>
        <div class="mr-3">
          <div :class="['circle', notificacion.corredurias_id && notificacion.corredurias_id !== 17 ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.corredurias_id && notificacion.corredurias_id !== 17" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer justify-content-between" v-if="!isCorredorAsignado">
        <div class="ml-3">
          <a :class="selectedComponent === 'Fad' ? 'active-menu' : 'text-menu'" @click="selected('Fad')">FAD</a>
        </div>
        <div class="mr-3">
          <div :class="['circle', [11, 12, 13, 23, 58].includes(notificacion.id_estatus) ? 'completado' : '']">
            <span class="number">
              <i v-if="[11, 12, 13, 23, 58].includes(notificacion.id_estatus)" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer justify-content-between">
        <div class="ml-3">
          <a
            :class="selectedComponent === 'DocumentosOriginales' ? 'active-menu' : 'text-menu'"
            @click="selected('DocumentosOriginales')"
          >
            Documentos Originales
          </a>
        </div>
        <div class="mr-3">
          <div :class="['circle', treeDocumentosOriginalesComputed ? 'completado' : '']">
            <span class="number">
              <i v-if="treeDocumentosOriginalesComputed" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 text-center mb-3">
        <label>Diligencia</label>
      </div>

      <div class="row flex align-items-center p-2 pointer justify-content-between">
        <div class="ml-3">
          <a
            class="f12"
            :class="selectedComponent === 'Diligencia' ? 'active-menu' : 'text-menu'"
            @click="selected('Diligencia')"
          >
            Gestión de Diligencia
          </a>
        </div>
        <div class="mr-3">
          <div :class="['circle', [12, 13, 23, 58].includes(notificacion.id_estatus) ? 'completado' : '']">
            <span class="number">
              <i v-if="[12, 13, 23, 58].includes(notificacion.id_estatus)" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer justify-content-between">
        <div class="ml-3">
          <a :class="selectedComponent === 'Actas' ? 'active-menu' : 'text-menu'" @click="selected('Actas')">Actas</a>
        </div>
        <div class="mr-3">
          <div :class="['circle', notificacion.id_estatus == 12 || notificacion.id_estatus == 13 ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.id_estatus == 12 || notificacion.id_estatus == 13" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer justify-content-between">
        <div class="ml-3">
          <a :class="selectedComponent === 'Expediente' ? 'active-menu' : 'text-menu'" @click="selected('Expediente')">
            Expediente
          </a>
        </div>
        <div class="mr-3">
          <div :class="['circle', notificacion.id_estatus == 13 ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.id_estatus == 13" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer justify-content-between">
        <div class="ml-3">
          <a :class="selectedComponent === 'Terminado' ? 'active-menu' : 'text-menu'" @click="selected('Terminado')">Terminado</a>
        </div>
        <div class="mr-3">
          <div :class="['circle', notificacion.id_estatus == 13 ? 'completado' : '']">
            <span class="number">
              <i v-if="notificacion.id_estatus == 13" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Storage from "@/utils/storage";

const storage = new Storage();

export default {
  name: "TreeNotificaciones",

  props: {
    notificacion: { type: Object },
    user: { type: String },
    selectedComponent: { type: String },
  },

  created() {
    const correduriasId = storage.getItem("corredurias_id");
    const rol = storage.getItem("role");

    if (correduriasId !== 1 && rol.toLowerCase().includes("staff")) {
      this.isCorredorAsignado = true;
    }

    this.clausulasConfirmacionDocumentoOriginales = this.notificacion.clausulas_confirmacion;
  },

  data() {
    return {
      isCorredorAsignado: false,
      clausulasConfirmacionDocumentoOriginales: [],
    };
  },

  computed: {
    treeDocumentosOriginalesComputed() {
      const result = this.clausulasConfirmacionDocumentoOriginales
        .filter((d) => [11, 12, 13].includes(d.clausula_confirmacion_id))
        .every((d) => d.confirmado);

      return result;
    },
  },

  methods: {
    selected(node) {
      this.$emit("node", node);
    },
  },
};
</script>

<style scoped>
.completado {
  background-color: yellowgreen !important;
}

.number {
  font-size: 11px;
  color: white;
}
</style>
